import React from "react";
import styled, { keyframes } from "styled-components";
import { media, breakpoints } from "../../components/common/mixins";
import { Container } from "../../components/common/Container";
import {
  OlympiacosScopedGlobalStyle,
  Section,
  EventsContainer,
  EventsGrid,
} from "./olympiacos-page.styles";

const pulse = keyframes`
  0%   { opacity: 1; }
  50%  { opacity: 0.4; }
  100% { opacity: 1; }
`;

const SkeletonBox = styled.div`
  background-color: #e9e8ec;
  border-radius: 8px;
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

// ── Hero Banner ──────────────────────────────────────────────────────────────

const SkeletonHeroBanner = styled(SkeletonBox)`
  position: relative;
  height: 262px;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  border-radius: 0;

  ${media.below(breakpoints.mobile)} {
    height: 180px;
  }
`;

const HeroBannerWrapper = styled.div`
  position: relative;
  height: 262px;

  ${media.below(breakpoints.mobile)} {
    height: 180px;
  }
`;

// ── Skeleton pieces ──────────────────────────────────────────────────────────

const Line = styled(SkeletonBox)<{ width?: string; height?: string }>`
  height: ${({ height }) => height ?? "14px"};
  width: ${({ width }) => width ?? "100%"};
  border-radius: 4px;
`;

const SkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 3.84px 7.679px 0 rgba(0, 0, 0, 0.08);
`;

const SkeletonCardImage = styled(SkeletonBox)`
  width: 100%;
  height: 160px;
  border-radius: 0;
`;

const SkeletonCardInfo = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

const SkeletonInfoBanner = styled(SkeletonBox)`
  height: 220px;
  width: 100%;
  border-radius: 8px;
  margin-bottom: 50px;

  ${media.above(breakpoints.tablet)} {
    height: 192px;
  }
`;

// ── Component ────────────────────────────────────────────────────────────────

const SkeletonCardItem = () => (
  <SkeletonCard>
    <SkeletonCardImage />
    <SkeletonCardInfo>
      <Line width="50%" height="16px" />
      <Line width="100%" height="30px" />
      <Line width="100%" height="16px" style={{ marginTop: "auto" }} />
    </SkeletonCardInfo>
  </SkeletonCard>
);

export function OlympiacosPageSkeleton() {
  return (
    <div>
       <OlympiacosScopedGlobalStyle />
      <HeroBannerWrapper>
        <SkeletonHeroBanner />
      </HeroBannerWrapper>
      <Container>
        <Section>
          <EventsContainer>
            <Line width="261px" height="30px" />
            <EventsGrid>
              <SkeletonCardItem />
              <SkeletonCardItem />
            </EventsGrid>
          </EventsContainer>
          <SkeletonInfoBanner />
        </Section>
      </Container>
    </div>
  );
}
